var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9794 10.5817L13.3436 13.3378C13.2543 13.7274 12.9118 14 12.5107 14C5.61147 13.9995 0 8.3888 0 1.49032C0 1.08948 0.272616 0.746608 0.662328 0.657745L3.41884 0.0220348C3.82028 -0.0709839 4.23048 0.137365 4.39729 0.517479L5.66944 3.48413C5.81815 3.83356 5.71785 4.24069 5.42387 4.48075L3.95155 5.66277C4.88077 7.5554 6.41983 9.09423 8.31329 10.0239L9.51871 8.55285C9.7563 8.2581 10.1665 8.15612 10.516 8.30746L13.4831 9.57915C13.84 9.76685 14.0724 10.1825 13.9794 10.5817Z",
    fill: "#FCCA19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.bc57e3abd2bccb376fccd0e82a178d15.svg";
export { ForwardRef as ReactComponent };